import {
    getMobileCode as getMobileCodeAjax,
    setMemberMobile,
    checkCaptcha,
} from '@/api/member';
import { mobiIng } from '@/shared/fai';
import { getSignMobileCodeCountDown } from '@/system/member/method';
import { changeValidateCode } from '@/system/member/login/method';
import { initWebPage } from '@/shared/misc/init-webpage';

import { showMemberLoginMsg } from '@/shared/member';
let mobileEditFuc = {};

mobileEditFuc.init = function (js_faiEncrypt, js_faiEncrypt_N) {
    if (js_faiEncrypt != '' && js_faiEncrypt_N != '') {
        var jmscript = document.createElement('script');
        jmscript.type = 'text/javascript';
        jmscript.src = js_faiEncrypt;

        var jmscript_N = document.createElement('script');
        jmscript_N.type = 'text/javascript';
        jmscript_N.src = js_faiEncrypt_N;

        var docHtml = document.documentElement || document.body;
        docHtml.appendChild(jmscript);
        docHtml.appendChild(jmscript_N);
    }
};
mobileEditFuc.revert = function () {
    jm('#inputMobile').show();
    jm('#mobileValidate').hide();
};
mobileEditFuc.save = function () {
    if (jm('#saveMobileBtn').hasClass('un-change')) {
        return;
    }
    if (jm('#inputMobile').css('display') == 'none') {
        // 提交修改手机号
        var mobile = jm('#mobile').val(),
            mobileCt = jm('#mobileCt').val(),
            validateCode = jm('#validateCodeInput').val();

        if (!mobile || mobile == '') {
            mobiIng('请输入手机号码');
            return;
        }
        if (!validateCode || validateCode == '') {
            mobiIng(LS.memberSignupRegisterCaptchaEmpty);
            return;
        }

        let option = {
            mobile,
            mobileCt,
            propVals: jm.toJSON({
                countryCode: jm('#mobileCt').find('option').text().trim(),
                validateCode,
            }),
            mobileSign: Fai.top.tmpMobileCodeSgin,
        };
        setMemberMobile(option)
            .catch(() => {
                showMemberLoginMsg(-1, 'ajax net error');
            })
            .then((data) => {
                if (!data.success) {
                    mobiIng(data.msg);
                    return;
                }

                mobiIng(data.msg, 1);
                setTimeout(function () {
                    document.location.reload();
                }, 1000);
            });
    } else {
        // 获取验证码
        mobileEditFuc.getMobileCode();
    }
};
// 获取短信
mobileEditFuc.getMobileCode = /*#__PURE__*/ function () {
    if (VITE_APP_MODE !== 'visitor') {
        mobiIng(
            '您目前处于网站管理状态，请先点击网站右上方的“退出”后再获取短信验证码。'
        );
        return;
    }

    var mobile = jm('#mobile').val(),
        mobileCt = jm('#mobileCt').val(),
        // memberSignupCaptcha = jm("#memberSignupCaptcha").val() || "",
        mCode = '';

    if (mobileCt == 'ch' && !jm.isMobile(mobile)) {
        mobiIng('手机号码不正确，请输入11位数字。');
        return;
    }
    if (!jm.isNationMobile(mobile)) {
        mobiIng(LS.mobileNumRegular);
        return;
    }

    if (Fai.top._encryptType) {
        // 引用脚本：js_faiEncrypt
        if (
            typeof mobile != 'undefined' &&
            Fai.top._faiEncryptKey &&
            Fai.top._encryptType > 0
        ) {
            // eslint-disable-next-line no-undef
            var encrypt = new JSEncrypt();
            encrypt.setPublicKey(Fai.top._faiEncryptKey);
            if (Fai.top._encryptType == 1) {
                // eslint-disable-next-line no-undef
                encrypt = new JSEncrypt1();
            } else if (Fai.top._encryptType == 2) {
                // eslint-disable-next-line no-undef
                encrypt = new JSEncrypt2();
            } else if (Fai.top._encryptType == 3) {
                // eslint-disable-next-line no-undef
                encrypt = new JSEncrypt3();
            }
            encrypt.setPublicKey(Fai.top._faiEncryptKey);
            mCode = encrypt.encrypt(mobile);
        }
    }

    var bssKey = 'AObmzq0GCAEQARoDWzldIgnllJDkuJbmsJE';
    var getCodeAction = function (checkSign) {
        let option = {
            mobile,
            mobileCt,
            mCode,
        };
        if (checkSign) {
            Object.assign(option, {
                bssKey,
                checkSign,
            });
        }

        getMobileCodeAjax(option)
            .catch(() => {
                mobiIng(LS.getMobileCodeErrAf);
            })
            .then((data) => {
                if (data.success) {
                    mobileEditFuc.needCaptcha = false;
                    mobiIng(LS.sendMobileCodeSuc);
                    getSignMobileCodeCountDown(60, '4.37rem');

                    jm('#inputMobile').hide();
                    jm('#mobileValidate').show();

                    Fai.top.tmpMobileCodeSgin = data.mobileCodeSign;
                } else {
                    if (data.needCode) {
                        jm('#showCaptcha').click();
                    }

                    if (data.rt == -401) {
                        if (!mobileEditFuc.needCaptcha) {
                            //上次不需要校验验证码
                            mobiIng(LS.memberSignupRegisterCaptchaEmpty);
                        } else {
                            mobiIng(LS.memberSignupRegisterCaptchaNotMatch);
                        }
                    } else if (data.rt == -2) {
                        if (data.msg) {
                            mobiIng(data.msg);
                        } else {
                            mobiIng(LS.js_argsError);
                        }
                    } else if (data.rt == 2) {
                        mobiIng(LS.memberDialogSendMobileCodeErr);
                    } else if (data.rt == -4 || data.rt == 8) {
                        mobiIng(LS.getMobileOneMin);
                    } else if (data.rt == -8) {
                        mobiIng(LS.getMobileHalfHour);
                    } else if (data.rt == 3) {
                        mobiIng(LS.memberDialogMobileMoneyErr);
                    } else if (data.rt == 9) {
                        mobiIng(LS.memberDialogSendMobileCodeLimit);
                    } else if (data.rt == 101) {
                        mobiIng(LS.mobileSetErr);
                    } else if (data.rt == -6) {
                        mobiIng(LS.mobileHasSigned);
                    } else if (data.rt == 23) {
                        mobiIng(LS.mobileNationTplErr);
                    } else if (data.rt == -301) {
                        mobiIng(LS.smsRanout);
                    } else {
                        mobiIng(LS.getMobileRefresh);
                    }

                    mobileEditFuc.needCaptcha = data.needCode || false;
                    if (mobileEditFuc.needCaptcha) {
                        //需要滑动验证
                        mobileEditFuc.getMobileCode();
                    }
                }
            });
    };

    if (mobileEditFuc.needCaptcha) {
        // eslint-disable-next-line no-undef
        initFaitest(
            {
                bss: 1,
                bssKey,
            },
            function (checkSign) {
                getCodeAction(checkSign);
            }
        );
    } else {
        getCodeAction();
    }
};

mobileEditFuc.infoInputChange = function () {
    jm('#saveMobileBtn').removeClass('un-change');
    if (jm('#mobile').val() == '') {
        jm('#cleanBtn').hide();
    } else {
        jm('#cleanBtn').show();
    }
    if (jm('#validateCodeInput').val() == '') {
        jm('#cleanValidateCodeInput').hide();
    } else {
        jm('#cleanValidateCodeInput').show();
    }
};
mobileEditFuc.cleanMobileInput = function () {
    jm('#mobile')[0].value = '';
    jm('#cleanBtn').hide();
};
mobileEditFuc.cleanValidateCodeInput = function () {
    jm('#validateCodeInput')[0].value = '';
    jm('#cleanValidateCodeInput').hide();
};
mobileEditFuc.initCaptchaPanel = function (needCaptcha) {
    mobileEditFuc.needCaptcha = needCaptcha;
    var createCaptchaPanel = function () {
        var shareHtml = '';
        shareHtml =
            "<div class='p_validateCode'>" +
            "<div class='contain'>" +
            "<img id='mobileEditCaptchaImg' class='captcha_img' src='validateCode.jsp?" +
            parseInt(Math.random() * 1000) +
            "' />" +
            "<div class='refreshCaptcha' onclick='Mobi.changeValidateCode(jm(\"#mobileEditCaptchaImg\"))'>" +
            "<div class='refreshCaptchaIcon icon-refresh'></div>" +
            "<div class='refreshCaptchaText'>看不清，换一张</div>" +
            '</div>' +
            "<div><input id='memberSignupCaptcha' class='validateCodeInput' maxlength='8' placeholder='请输入验证码' /></div>" +
            '</div>' +
            "<div class='foot'>" +
            "<div class='hiddenCaptcha'>取消</div>" +
            "<div class='checkCaptcha' >确定</div>" +
            '</div>' +
            '</div>';
        return shareHtml;
    };
    var option = {
        triggerId: 'showCaptcha',
        pageBg: true,
        pageHtml: createCaptchaPanel(),
        direction: 'bottom',
        callback() {
            jm('.checkCaptcha')
                .unbind('click')
                .click(function () {
                    mobileEditFuc.checkCaptcha();
                });
        },
        closeWebPage: '.hiddenCaptcha',
    };
    initWebPage(option);
    // 拿到验证码图片
    changeValidateCode(jm('#mobileEditCaptchaImg'));
};

mobileEditFuc.checkCaptcha = function () {
    var captchaCode = jm('#memberSignupCaptcha').val() || '';
    if (captchaCode == '') {
        mobiIng(LS.memberSignupRegisterCaptchaEmpty);
        return;
    }
    checkCaptcha({
        captchaCode,
        needCaptcha: mobileEditFuc.needCaptcha,
    })
        .catch(() => {
            showMemberLoginMsg(-1, 'ajax net error');
        })
        .then((data) => {
            if (data.success) {
                mobileEditFuc.needCaptcha = false;
                jm('.hiddenCaptcha').click();
                mobileEditFuc.getMobileCode();
            } else {
                let rt = data.rt || 0;
                switch (rt) {
                    case -2:
                        mobiIng(LS.js_argsError);
                        break;
                    case -4:
                        mobiIng(LS.smsRanout);
                        break;
                    case -15:
                        mobiIng(LS.memberSignupRegisterCaptchaNotMatch);
                        break;
                    default:
                        mobiIng(LS.systemError);
                        break;
                }
            }
        });
};

export default mobileEditFuc;
